import{styled as a}from"@mui/material";var e=a("div")(({theme:a})=>`\n  display: flex;\n  gap: ${a.spacing(2)};\n`);export{e as RowCheckbox};
//# sourceMappingURL=styled.js.map